import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AdminDashboardService } from 'src/app/modules/admin-dashboard/admin-dashboard.service';
import { ApiService } from 'src/app/shared/services';

@Component({
  selector: 'app-admin-add-product',
  templateUrl: './admin-add-product.component.html',
  styleUrls: ['./admin-add-product.component.less']
})
export class AdminAddProductComponent implements OnInit, AfterViewInit {

  tierList = ['Gold', 'Silver', 'Bronze+', 'Bronze'];
  searchValue: string = '';
  tierValue: string[] = [];
  designCatalogList: any[] = [];
  innerWidth: number;
  originalList: any[] = [];
  noMsg = ''
  isLoading: boolean=true;
  pageNo: number = 0;
  statusOptions = [
    { label: 'New', value: 'new' },
    { label: 'Processing', value: 'processing' },
    { label: 'Published', value: 'published' },
    { label: 'Canceled', value: 'canceled' }
  ]
  selectedBrand = [];

  @ViewChild("pdReqDialog") pdReqDialog: TemplateRef<any>;
  @ViewChild("catalogLinkDialog") catalogLinkDialog: TemplateRef<any>;
 
  urls = '';
  catalogLink = '';
  status: { type: 'success' | 'error', message: string } | null = null;
  currentResponseLength: number = 0;
  userType: any;
  submitLoading: boolean;
  @ViewChild('editorWrapper') editorWrapper!: ElementRef;
  selectedStatus = '';
  brands: any[] = [];
  brandSearchCtrl = new FormControl('');
  filteredBrandOptions: any[] = [];
  statusCtrl = [];
  designerid = [];
  originalDesignerList = [];
  catalogSubscription: Subscription;
  routeSubscription: Subscription;
  constructor(
    private api: AdminDashboardService,
    private apiService: ApiService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private location: Location,
    private activeRoute:ActivatedRoute
  ) {
    this.innerWidth = window.innerWidth;
    this.userType = JSON.parse(localStorage.getItem("user"))?.authorization;

  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // If you clicked inside the input, do nothing
    if (target.closest('input')) return;
    if (this.editorWrapper && this.editorWrapper.nativeElement.contains(target)) {
      // If you clicked inside the editor wrapper, do nothing
      return;
    }
    this.designCatalogList.forEach(f => {
      f.editNotes = false;
      f.editStatus = false;
    })
    // If in edit mode, exit it
    // if (this.isEditing) {
    //   this.save();
    //   this.isEditing = false;
    // }
  }

  ngOnInit() {
    this.getBrands();
    this.getDesignProfile();




    this.brandSearchCtrl.valueChanges.subscribe(searchText => {
      const search = searchText.toLowerCase();
      this.filteredBrandOptions = this.brands.filter(option =>
        option.name?.toLowerCase().includes(search)
      );
    });
        this.routeSubscription = this.activeRoute.queryParams.subscribe((params) => {

  // arrays (split by comma if present)
  this.designerid = params['requested_by']
    ? params['requested_by'].split(',').map(Number) // assuming IDs are numbers
    : [];

  this.statusCtrl = params['status']
    ? params['status'].split(',')
    : []; 
  this.selectedBrand = params['vendor_id']
    ? params['vendor_id'].split(',') 
    : [];
 
});
  }
  getDesignProfile() {
    this.apiService.getDesignProfile().subscribe((res) => {
      this.originalDesignerList = JSON.parse(JSON.stringify(res))
    });
  }

  getBrands() {
    this.apiService.getBrands().subscribe((value: any) => {
      this.brands = value;
      if (this.brands) {
        this.brands.sort((a, b) => a.name.localeCompare(b.name));


        this.filteredBrandOptions = JSON.parse(JSON.stringify(this.brands))
      }
      this.getDesignCatalog();
    });
  }

  filterChanged() {
    this.pageNo = 1;
    if (this.catalogSubscription) {
      this.catalogSubscription.unsubscribe();
    }
    this.designCatalogList = [];
    this.getDesignCatalog();
  }


  get allowUser() {
    return ('' + this.userType).includes('9')
  }

  loadMore() {
    this.pageNo++;
    this.getDesignCatalog(this.pageNo);
  }
  clearStatus() {
    this.statusCtrl = [];
    this.designCatalogList = [];
    this.pageNo = 1;
    this.getDesignCatalog();
  }

  clearBrand() {
    this.selectedBrand = [];
    this.designCatalogList = [];
    this.pageNo = 1;
    this.getDesignCatalog();
  }

  clearDesigner() {
    this.designerid = [];
    this.designCatalogList = [];
    this.pageNo = 1;
    this.getDesignCatalog();

  }

  getDc(){
        this.designCatalogList = [];
    this.pageNo = 0;
    this.getDesignCatalog();
  }

  getDesignCatalog(page = 0) {
    
    this.isLoading = true;
    this.pageNo = page;



    let filters = `&requested_by=${this.designerid.join(',')}&status=${this.statusCtrl.join(',')}&vendor_id=${this.selectedBrand.join(',')}&room_id=`

    let params = new HttpParams();

    // add values only if they exist
    if (this.designerid?.length) {
      params = params.set('requested_by', this.designerid.join(','));
    }

    if (this.statusCtrl?.length) {
      params = params.set('status', this.statusCtrl.join(','));
    }

    if (this.selectedBrand?.length) {
      params = params.set('vendor_id', this.selectedBrand.join(','));
    }

    this.location.replaceState(
      window.location.pathname,
      params.toString(),
      this.location.getState()
    );

    this.catalogSubscription = this.api.getDesignCatalog(page, filters).subscribe((res: any) => {
      if (res.data && res.data.length > 0) {
        this.currentResponseLength = res.data.length;
        res.data.forEach((item: any) => {
          item.showFullDescription = false; item.editNotes = false;
          item.editStatus = false;
          item.selected = false;
          item.saving = '';
          item.brandName = this.brands.find(b => b.value?.toLowerCase() === item.vendor_id?.toLowerCase())?.name ||
            item.vendor_id;
        });
        this.originalList = JSON.parse(JSON.stringify([...this.originalList, ...res.data]));
        this.designCatalogList = [...this.designCatalogList, ...res.data];
        this.isLoading = false;

      } else {
        this.noMsg = 'No Design Catalog Found';
        this.isLoading = false;

      }
    }, err => {
      this.noMsg = 'No Design Catalog Found';
      this.isLoading = false;
    })
  }

  setStatus() {
    const selectedItems = this.designCatalogList.filter(item => item.selected);
    if (selectedItems.length === 0) {
      this.snackbar.open('Please select at least one item to update status.', 'x', { duration: 5000 });
      this.selectedStatus = '';
      return;
    }
    const data = selectedItems.map(item => ({
      id: item.id,
      status: this.selectedStatus,
      notes: item.notes || ''
    }));
    this.isLoading=true;
      this.designCatalogList = [];
    this.apiService.updateDesignCatalog({ data }).subscribe((res: any) => {
      if (res && res.status) {

        if (this.selectedStatus === 'published') {
          const ids = selectedItems.map(item => item.id).join(',');
          this.mailDesignCatalogUser({ ids: ids });
        }
        this.snackbar.open(`Product updated successfully.`, 'x', { duration: 5000 });

        this.getDc();
        // this.designCatalogList.forEach(item => {
        //   if (item.selected) {
        //     item.status = this.selectedStatus;
        //     item.selected = false;
        //     item.editStatus = false;
        //   }
        // });
        this.selectedStatus = '';
      }
    },err=>{
         this.designCatalogList = [];
    this.pageNo = 0;
    this.getDesignCatalog();
    });

  }

  @HostListener("window:resize")
  onResize() {
    this.innerWidth = this.apiService.isAdminSidePanelOpened ? window.innerWidth : window.innerWidth + 225;

  }

  updateDesignCatalog(item: any) {
    item.saving = 'Saving...';
    const data = [{
      "id": item.id,
      "status": item.status,
      "notes": item.notes,
    }];
    this.apiService.updateDesignCatalog({ data: data }).subscribe((res: any) => {
      if (res && res.status) {

        if (item.status === 'published') {
          this.mailDesignCatalogUser({ ids: item.id });
        }

        item.saving = 'Saved';
        item.editNotes = false;
        item.editStatus = false;
        this.snackbar.open(`Product updated successfully.`, 'x', { duration: 5000 });
        setTimeout(() => {
          item.saving = '';
          item.editNotes = false;

        }, 2000);
        // this.designCatalogList = [];
        // this.getDesignCatalog();
      } else {
        item.saving = '';
        this.snackbar.open(`There is an error in updating the product.`, 'x', { duration: 5000 });
      }
    }, err => {
      item.saving = '';
      this.snackbar.open(`There is an error in updating the product.`, 'x', { duration: 5000 });
    })
  }

  mailDesignCatalogUser(data) {
    this.apiService.mailDesignCatalogUser(data).subscribe((res: any) => {
      if (res && res.status) {
      } else {
      }
    }, err => {
      this.snackbar.open(`There is an error in sending the mail.`, 'x', { duration: 5000 });
    })
  }

  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);

    const intervalx = setInterval(() => {
      const intercomx = document.getElementsByClassName("intercom-app")[0];
      if (intercomx) {
        intercomx.classList.add("dn");
        clearInterval(intervalx);
      }
    }, 500);
  }
  ngAfterViewInit(): void {
    this.hideIntercomIcon();
  }

  panelStateChange() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  getColor(status: string) {
    if (status.toUpperCase() == "PROCESSING") {
      return {
        color: "#0DCAF0"
      };
    } else if (status.toUpperCase() == "PUBLISHED") {
      return {
        color: "#198754"
      };
    }
  }
  openUrl(url) {
    window.open(url, '_blank');
  }
currentCatData:any;
  openCatalogURL(data: any) {
    this.currentCatData = data;
    if (data.catalog_link) {
      window.open(data.catalog_link, '_blank');
    } else {
      this.catalogLink = '';
      this.status = null;
      this.dialog.open(this.catalogLinkDialog, {
        disableClose: true,
        width: '700px'
      });
    }
  }

  openAdd(s: any) {
    if (s.status !== 'new') return;
    const encoded = encodeURIComponent(JSON.stringify(s));
    window.open(`/design/designer/add-product?data=${encoded}`, '_blank');

  }


  openProductReq() {
    this.status = null;
    this.dialog.open(this.pdReqDialog, {
      disableClose: true,
      width: '700px'
    });
  }
  closeDialog() {
    this.status = null;
    this.dialog.closeAll();
  }
  onSubmit() {
    this.submitLoading = true;
    this.status = null;
    const lines = this.urls
      .split('\n')
      .map(url => url.trim())
      .filter(url => url.length > 0);

    if (lines.length === 0) return;

    const invalid = lines.filter(url => !url.startsWith('http'));
    if (invalid.length > 0) {
      this.status = { type: 'error', message: `${invalid.length} invalid URL(s) found.` };
      this.submitLoading = false;

    } else {
      this.apiService.addDesignCatalog({ product_url: lines }).subscribe((res: any) => {
        if (res && res.status) {
          this.designCatalogList = [];
          this.getDesignCatalog();
          this.submitLoading = false;
          this.closeDialog();
          this.snackbar.open(`${lines.length} products added successfully.`, 'x', { duration: 5000 });
          this.urls = '';
        } else {
          this.submitLoading = false;
          this.snackbar.open(`There is an error in adding the URL(s).`, 'x', { duration: 5000 });

        }
      }, err => {
        this.submitLoading = false;
        this.snackbar.open(`There is an error in adding the URL(s).`, 'x', { duration: 5000 });

      }
      )

    }
  }

    submitCatalogLink() {
    this.submitLoading = true;
    this.status = null;
      const data =[{
         id: this.currentCatData.id,
      status: this.currentCatData.status,
      notes: this.currentCatData.notes,
      catalog_link: this.catalogLink
      }]

    if (this.catalogLink?.length === 0) return;

    const invalid = !this.catalogLink.startsWith('http');
    if (invalid) {
      this.status = { type: 'error', message: `invalid URL.` };
      this.submitLoading = false;

    } else {
        this.apiService.updateDesignCatalog({ data }).subscribe((res: any) => {

        if (res && res.status) {
          this.designCatalogList = [];
          this.getDesignCatalog();
          this.submitLoading = false;
          this.closeDialog();
          this.snackbar.open(`Link added successfully.`, 'x', { duration: 5000 });
          this.urls = '';
        } else {
          this.submitLoading = false;
          this.snackbar.open(`There is an error in adding the URL.`, 'x', { duration: 5000 });

        }
      }, err => {
        this.submitLoading = false;
        this.snackbar.open(`There is an error in adding the URL.`, 'x', { duration: 5000 });

      }
      )

    }
  }
} 